<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="补货上架" @click-left="onClickLeft" @click-right="goIndex()" />
    <div>
      <van-cell-group>
        <van-field ref="barcode" v-model="barcodeNo" autofocus label="条码" left-icon="photograph" placeholder="请扫描条码" @keyup="onBarcode" />
      </van-cell-group>
      <van-list v-model="loading" :finished="finished" :immediate-check="false" class="goodCard" finished-text="没有更多了">
        <van-cell  v-for="item in list" :key="item.index">
          <div ref="_itemData">
            <a>
              <div style="font-size: 16px;flex: 1;line-height: 24px;">
                上架货位：
                <span class="method1" ref="location" v-if="item.targetLocation.no">{{ item.targetLocation.no }}</span>
                <span v-else><input type="button" class="method1" value="编辑货位"  @click="locationClick(list[item.index])" style="cursor: pointer;border-radius: 12px;" /></span>
              </div>
              <div style="font-size: 14px;position: absolute;text-align: right; top: 50%;right: 5px;transform: translateY(-50%);">
                <input type="button" value="拆分"  class="fixedBtn method2" @click="splitClick(list[item.index])"  />
              </div>
            </a>

            <div style="display: flex;margin-bottom: 0px; line-height: 24px;">
              通用名称：<span>{{ item.item.name }}</span>
            </div>

            <div style="display: flex;margin-bottom: 0px; line-height: 24px;">
              <div style="flex: 1;">
                规格：<span>{{item.pack.specification}}</span>
              </div>
              <div style="flex: 1;">
                剂型：<span>{{item.item.dosageForm.name}}</span>
              </div>
            </div>

            <div style="display: flex;margin-bottom: 0px; line-height: 24px;">
              <div style="flex: 1;">
                包装：<span>{{ item.pack.factor }}</span>
              </div>
              <div style="flex: 1;">
                单位：<span>{{ item.pack.uom }}</span>
              </div>
            </div>

            <div style="display: flex;margin-bottom: 0px; line-height: 24px;">
              批号：<span>{{ item.lot.no }}</span>
            </div>

            <div style="display: flex;margin-bottom: 0px; line-height: 24px;">
              效期：<span>{{ item.lot.productionDate }} - {{ item.lot.validUntil }}</span>
            </div>

            <div style="display: flex;margin-bottom: 0px; line-height: 24px;">
              <div style="flex: 1;">
                数量：<span style="color: #D07569;font-weight: bold;">{{ item.command.quantity }}</span>
                <!--                                        <span style="font-size: 13px;display: inline-block;width: 24px;height: 24px;background: #8394A1;color: #fff;margin-left: 2px;text-align: center;line-height: 24px;border-radius: 2px;">{pack.uom}</span>-->
              </div>
              <div style="flex: 1;">
                件数：<span>{{ item.countable }}</span>
              </div>
              <div style="flex: 1;">
                零数：<span>{{ item.scatteredNumber }}</span>
              </div>
            </div>

            <div style="display: flex;margin-bottom: 0px; line-height: 24px;">
              生产厂商：<span>{{ item.pack.manufacturer }}</span>
            </div>
          </div>
        </van-cell>
      </van-list>
      <template>
        <van-dialog v-model="show1" title="扫描货位" show-cancel-button ref="" :before-close='locationDialog'>
          <van-field  v-model="locationNo" label="编号"  ref="_location" autofocus="true" />
        </van-dialog>
        <van-dialog v-model="show2" title="拆分" show-cancel-button ref="" :before-close="splitNumDialog">
          <van-field  v-model="splitNum" type="digit" label="数量"  ref="_splitNum" autofocus="true" />
        </van-dialog>
      </template>
      <van-tabbar fixed placeholder>
        <van-tabbar-item>
          <van-button round block type="info" style="margin: 8px; width: 100%" native-type="confirm" @click="confirm">确认
          </van-button>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import { findAll, post } from '@/api/Api'
import { Dialog, Toast } from 'vant'
import api from '@/api'
import { getUser } from '@/pdaView/utils'

export default {
  components: {},
  data() {
    return {
      loading: false,
      username: getUser().name,
      barcodeNo: '',
      finished: false,
      list: [],
      show1:false,
      show2:false,
      locationNo:'',
      data1:{},
      data2:{},
      splitNum:''
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    goIndex() {
      this.$router.push({ name: 'PdaIndex' }, (res) => {
      })
    },
    // test(a){
    //   console.log(a)
    //   if ( this.$refs._itemData[a.index].style.background){
    //     this.$refs._itemData[a.index].style.background=''
    //
    //   }else {
    //     this.$refs._itemData[a.index].style.background='#8f8f8f'
    //   }
    //   // 使用filter方法排除特定索引的元素
    //   const filteredArr = this.$refs._itemData.filter((element, index) => index !== a.index);
    //   _.forEach(filteredArr,item=>{
    //     item.style.background=''
    //   })
    //
    // },

    locationClick(data){
      this.data1=data
      this.show1=true
    },
    splitClick(data){
      this.data2=data
      this.show2=true
    },

    locationDialog(action, done){
      if (action === 'cancel') {
        this.locationNo=''
        done(); // 继续关闭流程
      } else if (action === 'confirm') {
        this.list[this.data1.index].targetLocation.no=this.locationNo
        this.locationNo=''
        done(); // 继续关闭流程
      }

    },
    splitNumDialog(action, done){
      if (action === 'cancel') {
        this.splitNum=''
      } else if (action === 'confirm') {
        let params = {
          sourceId: this.data2.command.id,
          newCommands: [
            {
              allocateQuantity: this.splitNum,
            }
          ],
        }
        post(api.receivingReceiverSplit,{},params).then(res => {
          if (res.success) {
            Toast('拆分成功！')
            this.splitNum=''
            this.scan(this.barcodeNo)
            done()
          }else {
            Toast(res.result)
            done(false)
          }
        })
      }
    },
    onBarcode: debounce(function(data, event) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.scan(value)
      }

    }, 300),

    scan(value) {
      if (!this.barcodeNo) {
        Toast('请先扫描条码！')
        return
      }
      let args = {
        'barcode.no': value
      }
      findAll('replenishCommandPutawayFactory', args).then(res => {

        let newData = {}
        if (res.success &&res.result.length>0) {
          Object.assign(newData, res)
          let index = 0
          _.forEach(newData.result, item => {
            console.log(item)
            if (item.targetLocation === null || item.targetLocation === undefined) {
              item.targetLocation = {
                id: '',
                no: '',
              }
            }
            let productionDateArr = item.lot.productionDate.split("-")
            item.lot.productionDate = productionDateArr[0] + '/' + productionDateArr[1] + '/' + productionDateArr[2]

            let validUntilArr = item.lot.validUntil.split("-")
            item.lot.validUntil = validUntilArr[0] + '/' + validUntilArr[1] + '/' + validUntilArr[2]
            //件数
            item.countable = (item.command.quantity - item.command.quantity % item.pack.factor) / item.pack.factor
            //零散数
            item.scatteredNumber = item.command.quantity % item.pack.factor
            item.index = index
            index++
          })
          this.list = newData.result
          this.loading = false
        }else {
          this.barcodeNo=''
        }
      })
      // this.list = [
      //   {
      //     item: {
      //       name: '可乐',
      //       dosageForm: '汽水'
      //     },
      //     index:0,
      //     targetLocation: {
      //       no: ''
      //     },
      //     pack: {
      //       specification: '12瓶/厢',
      //       factor: '1',
      //       uom: '瓶',
      //       manufacturer:'宜昌'
      //     },
      //     lot:{
      //       no:'20240709',
      //       productionDate:'2024/05/16',
      //       validUntil:'2025/05/16',
      //     },
      //     command:{
      //       quantity:"10"
      //     },
      //     countable:'1',
      //     scatteredNumber:'0'
      //   },
      //   {
      //     item: {
      //       name: '可乐',
      //       dosageForm: '汽水'
      //     },
      //     index:1,
      //     targetLocation: {
      //       no: ''
      //     },
      //     pack: {
      //       specification: '12瓶/厢',
      //       factor: '1',
      //       uom: '瓶',
      //       manufacturer:'宜昌'
      //     },
      //     lot:{
      //       no:'20240709',
      //       productionDate:'2024/05/16',
      //       validUntil:'2025/05/16',
      //     },
      //     command:{
      //       quantity:"10"
      //     },
      //     countable:'1',
      //     scatteredNumber:'0'
      //   },
      //   {
      //     item: {
      //       name: '可乐',
      //       dosageForm: '汽水'
      //     },
      //     index:2,
      //     targetLocation: {
      //       no: ''
      //     },
      //     pack: {
      //       specification: '12瓶/厢',
      //       factor: '1',
      //       uom: '瓶',
      //       manufacturer:'宜昌'
      //     },
      //     lot:{
      //       no:'20240709',
      //       productionDate:'2024/05/16',
      //       validUntil:'2025/05/16',
      //     },
      //     command:{
      //       quantity:"10"
      //     },
      //     countable:'1',
      //     scatteredNumber:'0'
      //   }
      // ]

    },
    confirm() {
     if (this.list.length>0){
       if (this.list[0].targetLocation.no) {
         let body = {
           "application": 4,
           "workMode": 5,
           "barcode.no": this.list[0].barcode.no
         }
         let params = {
           "barcode.no": this.list[0].barcode.no

         }
         post(api.replenishingObtain, { type: 'tabletObtainer' }, body).then(res => {
           if (res.success) {
             post(api.replenishingConfirm, { type: 'tabletConfirmer' }, params).then(res => {
               if (res.success) {
                 Toast('入库上架成功')
                 this.scan(this.barcodeNo)
               }
             })
           }
         })

       } else {
         Toast('请先选择货位')
       }
     }

    }

  }

}
</script>
<style>
.goodCard .x-listitem {
  border-bottom: none;
  border-top: none;
}

.goodCard .x-listitem-inner-el {
  padding: 0;
}

.goodCard .x-listitem {
  background-color: #fff;
  margin-top: 5px;
}

.goodCard:first-child .x-listitem {
  margin-top: 0px;
}

.goodCard .goodCardItem {
  font-family: '微软雅黑';
  position: relative;
  padding: 5px 12px;
}

.goodCard .goodCardItem > a {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: #333;
  margin-bottom: 5px;
}

.goodCard .goodCardItem > div,
.goodCard .goodCardItem > a > div {
  font-weight: bold;
  text-align: left;
  font-size: 14px;
  margin-bottom: 5px;
}

.goodCard .goodCardItem a {
  text-decoration: none;
}

.goodCard .goodCardItem > div span,
.goodCard .goodCardItem > a > div span {
  font-weight: normal;
}

.goodCard .goodCardItem .fixedBtn {
  cursor: pointer;
  color: #6B9AE1;
  border: none;
  border: 1px solid #6B9AE1;
  background: #fff;
}

.goodCard .goodCardItem .fixedBtn:hover {
  color: #fff;
  background-color: #589DF6;
}

.goodCard .goodCardItem .fixedBtn:active {
  color: #fff;
  background-color: #009DF6;
}
.goodCard .goodCardItem {
  --selected-background-color: rgba(224, 224, 224, 0.36863);
}
</style>